import React from 'react';
import { TrendingUp, ExternalLink } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Helmet } from 'react-helmet';

const Chart = () => {
  return (
    <div className="min-h-screen bg-black text-white pt-32 pb-20">
      <Helmet>
        <link rel="canonical" href="https://www.flumberico.fun/chart" />
      </Helmet>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <TrendingUp className="w-20 h-20 text-gold mx-auto mb-6" />
          <h1 className="text-6xl font-black mb-6 text-gold">
            Live Chart
          </h1>
          <p className="text-2xl text-silver font-semibold mb-4">Track $FLUMBERICO in Real-Time</p>
          <p className="text-lg text-silver/70">
            Contract: <span className="text-gold font-mono">Hu8PvhDSyVwNUYnXsWQ12DEX2baydRximcbaSAkKpump</span>
          </p>
        </div>

        {/* Quick Links */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          <a
            href="https://pump.fun/coin/Hu8PvhDSyVwNUYnXsWQ12DEX2baydRximcbaSAkKpump"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button 
              className="font-bold flex items-center gap-2" 
              style={{ backgroundColor: '#FFD700', color: '#000000' }}
            >
              Trade on Pump.fun <ExternalLink size={16} />
            </Button>
          </a>
          <a
            href="https://www.geckoterminal.com/solana/pools/4b1FkvmX38jdaYAiaTAQPnhZJmETxvUSBYnECKmwue6w"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button variant="outline" className="border-2 border-silver text-silver hover:!bg-silver hover:!text-black hover:!border-silver font-bold flex items-center gap-2 transition-all">
              View on GeckoTerminal <ExternalLink size={16} />
            </Button>
          </a>
        </div>

        {/* Embedded Chart */}
        <div className="bg-gradient-to-br from-gold/10 to-black/50 border border-gold/30 rounded-lg p-8 mb-8">
          <div className="text-center mb-6">
            <p className="text-white text-lg mb-4">
              View live trading data and charts for $FLUMBERICO
            </p>
          </div>
          
          <div className="relative w-full bg-black/50 rounded-lg overflow-hidden" style={{ minHeight: '600px' }}>
            <iframe
              src="https://birdeye.so/tv-widget/Hu8PvhDSyVwNUYnXsWQ12DEX2baydRximcbaSAkKpump?chain=solana&viewMode=pair&chartInterval=1D&chartType=CANDLE&theme=dark"
              className="w-full rounded-lg"
              style={{ border: 'none', height: '600px' }}
              title="FLUMBERICO Live Trading Chart on Birdeye"
              allowFullScreen
              loading="lazy"
            />
          </div>
          
          <div className="mt-6 text-center">
            <p className="text-white text-sm">
              Powered by <a href="https://birdeye.so" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline font-semibold">Birdeye ↗</a> | 
              <a href="https://www.geckoterminal.com/solana/pools/4b1FkvmX38jdaYAiaTAQPnhZJmETxvUSBYnECKmwue6w" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline font-semibold ml-2">View on GeckoTerminal ↗</a>
            </p>
          </div>
        </div>

        {/* Chart Info */}
        <div className="grid md:grid-cols-3 gap-6">
          <div className="bg-black/50 border border-gold/30 rounded-lg p-6 text-center">
            <h3 className="text-xl font-bold text-gold mb-2">Blockchain</h3>
            <p className="text-silver text-lg">Solana</p>
          </div>
          <div className="bg-black/50 border border-silver/30 rounded-lg p-6 text-center">
            <h3 className="text-xl font-bold text-silver mb-2">Listed On</h3>
            <p className="text-silver text-lg">Pump.fun</p>
          </div>
          <div className="bg-black/50 border border-gold/30 rounded-lg p-6 text-center">
            <h3 className="text-xl font-bold text-gold mb-2">Type</h3>
            <p className="text-silver text-lg">Meme Coin / Utility</p>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-12 bg-red-950/20 border border-red-500/40 rounded-lg p-6">
          <p className="text-white text-sm text-center">
            <span className="font-bold text-red-400">Disclaimer:</span> Trading cryptocurrencies involves significant risk. Past performance does not guarantee future results. Always do your own research and never invest more than you can afford to lose.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Chart;